import { useEffect } from "react";
import {
  useCountryBlockingActions,
  useCountryBlockingHasBeenChecked,
  useIsCountryBlockingBlocked,
  useIsCountryBlockingChecking,
} from "../../core_stores/useCountryBlockingStore";
import { ErrorScreenLayout } from "../common_components/ErrorScreenLayout";

interface CountryBlockingWrapperProps {
  children: React.ReactNode;
}

export function CountryBlockingWrapper({
  children,
}: CountryBlockingWrapperProps) {
  const isChecking = useIsCountryBlockingChecking();
  const isBlocked = useIsCountryBlockingBlocked();
  const hasBeenChecked = useCountryBlockingHasBeenChecked();
  const { checkAccess } = useCountryBlockingActions();

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  // Only block if user is explicitly blocked (not during check)
  // Render app immediately for seamless experience
  if (isBlocked && hasBeenChecked) {
    return (
      <ErrorScreenLayout
        isLoading={false}
        info="Looks like Darvin is not available in your country :("
      />
    );
  }

  // Show app immediately, even while checking
  return <>{children}</>;
}
